import axios from 'axios'

// API Endpoints
const CHECK_TENANT_SERVICE_REFRESHTOKEN_URL = 'api/Administration/ServiceRefreshTokens/check/'
const GENERATE_TENANT_SERVICE_REFRESHTOKEN_URL = 'api/Administration/ServiceRefreshTokens/generate'
let initialState = () => ({
    
})

export default {
  namespaced: true,
  state: initialState,
  actions: {
    async checkTenantServiceRefreshToken({ commit }, data){
      try {
        let response = await axios.get(CHECK_TENANT_SERVICE_REFRESHTOKEN_URL + data.tenantName)
        return response.data
                //commit(ADD_SERVICE, response.data)
      } catch (error) {
        throw error.response.data
      }
    },
    async generateTenantServiceRefreshToken({ commit }, data){
      try {
        let response = await axios.post(GENERATE_TENANT_SERVICE_REFRESHTOKEN_URL, data)
        return response.data
                //commit(ADD_SERVICE, response.data)
      } catch (error) {
        throw error.response.data
      }
    },
  },
  mutations: {},
  getters: {},
}